import Model from '../model/billingCycle';

export const viewModelToModel = (view) => {
  try {
    if (!view) return null;

    const model = { ...Model };

    model.Id = view.id || '';
    model.OrderSubscriptionId = view.orderSubscriptionId || '';
    model.OrderId = view.orderId || '';
    model.PolicyNumber = view.policyNumber || '';
    model.BillingCycle = view.billingCycle || 0;
    model.Amount = view.amount || 0;
    model.SplitPayers = view.splitPayers || [];
    model.Status = view.status || '';
    model.DueDate = view.dueDate || '';
    model.ProcessingDate = view.processingDate || '';
    model.CreatedAt = view.createdAt || '';
    model.UpdatedAt = view.updatedAt || '';

    // Map StatusDetail
    if (view.statusDetail) {
      model.StatusDetail = {
        Status: view.statusDetail.status || '',
        Description: view.statusDetail.description || '',
      };
    }

    // Map Order
    if (view.order) {
      model.Order = {
        Id: view.order.id || '',
        Code: view.order.code || '',
        Amount: view.order.amount || 0,
        Discount: view.order.discount || 0,
        Status: view.order.status || '',
        StatusDetail: {
          Status: (view.order.statusDetail && view.order.statusDetail.status) || '',
          Description: (view.order.statusDetail && view.order.statusDetail.description) || '',
        },
        Items: view.order.items || [],
        Events: view.order.events || [],
        ExpiresAt: view.order.expiresAt || '',
        CreatedAt: view.order.createdAt || '',
        UpdatedAt: view.order.updatedAt || '',
      };
    }

    // Map PaymentInstrument with Card details
    if (view.paymentInstrument) {
      model.PaymentInstrument = {
        Id: view.paymentInstrument.id || '',
        Type: view.paymentInstrument.type || '',
        Status: view.paymentInstrument.status || '',
        Card: null,
      };

      if (view.paymentInstrument.card) {
        const {
          id, type, bin, lastFourDigits, expMonth, expYear,
          principal, createdAt, updatedAt, holder, brand, billingAddress,
        } = view.paymentInstrument.card;

        model.PaymentInstrument.Card = {
          Id: id || '',
          Type: type || '',
          Bin: bin || '',
          LastFourDigits: lastFourDigits || '',
          ExpMonth: expMonth || '',
          ExpYear: expYear || '',
          Principal: principal || false,
          CreatedAt: createdAt || '',
          UpdatedAt: updatedAt || '',
          Holder: {
            Name: (holder && holder.name) || '',
            TaxId: (holder && holder.taxId) || '',
          },
          Brand: {
            Name: (brand && brand.name) || '',
            Code: (brand && brand.code) || '',
            LogoUrl: (brand && brand.logoUrl) || '',
          },
          BillingAddress: {
            Id: (billingAddress && billingAddress.id) || '',
            ZipCode: (billingAddress && billingAddress.zipCode) || '',
            Street: (billingAddress && billingAddress.street) || '',
            StreetNumber: (billingAddress && billingAddress.streetNumber) || '',
            Neighborhood: (billingAddress && billingAddress.neighborhood) || '',
            City: (billingAddress && billingAddress.city) || '',
            State: (billingAddress && billingAddress.state) || '',
            Country: (billingAddress && billingAddress.country) || '',
          },
        };
      }
    }

    // Map Events
    model.Events = view.events || [];

    return model;
  } catch (error) {
    throw new Error(`BillingCycleMapper - ViewModelToModel = ${error}`);
  }
};

export const viewsModelToModels = (models) => {
  try {
    if (!models) return null;

    const views = [];

    models.forEach(async (model) => {
      const view = viewModelToModel(model);

      views.push(view);
    });

    return views;
  } catch (error) {
    throw new Error(`ItemMapper - ViewsModelToModels = ${error}`);
  }
};

export const modelToViewModel = (model) => {
  try {
    if (!model) return null;

    const view = {};

    view.Sku = model.Sku;
    view.Name = model.Name;
    view.Value = model.Value;
    view.Quantity = model.Quantity;

    return view;
  } catch (error) {
    throw new Error(`ItemMapper - ModelToViewModel = ${error}`);
  }
};

export const modelsToViewsModel = (models) => {
  try {
    if (!models) return null;

    const views = [];

    models.forEach(async (model) => {
      const view = modelToViewModel(model);

      views.push(view);
    });

    return views;
  } catch (error) {
    throw new Error(`ItemMapper - ModelsToViewsModel = ${error}`);
  }
};

export const viewModelToState = (view) => {
  try {
    if (!view) return null;

    const model = { ...Model };

    model.Sku = view.Sku;
    model.Name = view.Name;
    model.Value = view.Value;
    model.Quantity = view.Quantity;

    return model;
  } catch (error) {
    throw new Error(`ItemMapper - ViewModelToState = ${error}`);
  }
};
